export const VISIT_CUSTOMS_GUIDE = {
  KOR: {
    title: '세관을 방문하지 못하셨나요?',
    contents: '‘문의하기’를 통해 메시지 주시면 처리해드리겠습니다.',
  },
  CHN: {
    title: '没能访问海关吗？',
    contents: '如果您向我们发送咨询事项，我们将为您处理。',
  },
  USA: {
    title: 'Have you not been able to visit the customs?',
    contents:
      'Please send a message through Inquiry then we will take care of it.',
  },
};

export const REFUND_ONLY_TEXT = {
  KOR: {
    PAYMENT_WAIT: {
      title: '환급액을 송금중이에요.',
      contents:
        '환급액을 송금중이에요. 송금까지 영업일 기준 14일정도 소요되니 조금만 기다려주세요.',
    },
    PAYMENT_COMPLETE: {
      title: '환급이 완료되었어요!',
      contents: '환급액 송금이 완료되었어요. 계좌를 확인해주세요.',
    },
  },
  CHN: {
    PAYMENT_WAIT: {
      title: '正在汇款中',
      contents: '退款金额正在汇款中。退款需要14个工作日左右。',
    },
    PAYMENT_COMPLETE: {
      title: '退款完毕',
      contents: '汇款已完成。请确认一下账户。',
    },
  },
  USA: {
    PAYMENT_WAIT: {
      title: 'Transferring your Refund',
      contents: 'Tax refund will be completed about 14 business days.',
    },
    PAYMENT_COMPLETE: {
      title: 'Remittance Completed',
      contents: 'The remittance has been completed. Please check your account.',
    },
  },
};

export const REFUND_BOTH_TEXT = {
  KOR: {
    PAYMENT_WAIT: {
      title: '세관 방문',
      contents:
        '세관 방문 후, 아래 버튼을 클릭하여 모바일 Tax refund 영수증과 구매한 물건을 세관 직원에게 보여주세요.',
    },
    PAYMENT_COMPLETE: {
      title: '환급이 완료되었어요!',
      contents: '환급액 송금이 완료되었어요. 계좌를 확인해주세요.',
    },
  },
  CHN: {
    PAYMENT_WAIT: {
      title: '访问海关',
      contents: '访问海关后，请按下端按钮向职员出示税金收据和购买物品。',
    },
    PAYMENT_COMPLETE: {
      title: '退款完毕',
      contents: '汇款已完成。请确认一下账户。',
    },
  },
  USA: {
    PAYMENT_WAIT: {
      title: 'Visit Customs',
      contents:
        'After visiting customs, click the button below to show your mobile tax refund receipt and your purchase to custom officers.',
    },
    PAYMENT_COMPLETE: {
      title: 'Remittance Completed',
      contents: 'The remittance has been completed. Please check your account.',
    },
  },
};
